// yup email valdation is broken: https://github.com/jquense/yup/issues/507
export const EMAIL_REGX = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\\d{1,3}\.\\d{1,3}\.\\d{1,3}\.\\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);

export const PASSWORD_REGX = new RegExp(
  // /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{10,}$/,
  /^(?=.*\d)(?=.*[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])(?=.*[a-z])(?=.*[A-Z]).{10,}$/,
);

enum TrackingSuppressionAttributes {
  HotJar = 'data-hj-suppress',
}

export const trackingSuppressionAttributes = {
  [TrackingSuppressionAttributes.HotJar]: true,
};

/**
 * Fields returned by Saleor in error.field which should not be
 * mapped to any form.
 */
export const GENERIC_API_FIELDS = [
  'checkout',
  'order',
  'checkoutId',
  'token',
  'deliveryMethodId',
  'adyen',
  '__root__',
];

export const MAX_CHAR = 50;

export const MAX_CHAR_FIRST_NAME = 40;

export const MAX_CHAR_LAST_NAME = 80;

export const MAX_CHAR_PHONE = 20;

export const MAX_CHAR_ADDRESS = 200;

export const SALESFORCE_TEXT_MAX_LENGTH = 255;

export const GIFT_MESSAGE_MAX_LENGTH = 130;

export const CONTENTSQUARE_MASKED = 'pii';

export const MIN_CHAR_NAME = 1; // chinese name have 1 chars

export const PREFER_NOT_TO_SAY = 'NOTTOSAY';
